import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BillableHoursChartData,
  IBillingDetail,
} from 'src/app/interfaces/home.interface';
import { HomeService } from 'src/app/services/home/home.service';

@Component({
  selector: 'app-billable-hours',
  templateUrl: './billable-hours.component.html',
  styleUrls: ['./billable-hours.component.scss'],
})
export class BillableHoursComponent implements OnInit {
  public billingDetail!: IBillingDetail;
  public total!: number;
  public initializeChart = false;
  width = 150;
  height = 150;
  legendData: any = [
    { color: '#487DC1', text: 'Billable Hours' },
    { color: '#71B06B', text: 'Non Billable Hours' },
  ];
  billableHoursChartData: BillableHoursChartData[] = [
    
    {
      id: 1,
      color: '#487dc1',
    },
    {
      id: 2,
      color: '#71b06b',
    },
  ];
  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id)
      this.homeServiceRef.getBillingDetail(id).subscribe((res) => {
        if (!!res) {
          this.total = res.billableHours + res.nonBillableHours;
          this.billableHoursChartData[1].value =
            (res.nonBillableHours / this.total) * 100;
          this.billableHoursChartData[0].value =
            (res.billableHours / this.total) * 100;
          this.initializeChart = true;
        }
      });
  }
}
